import page404 from '../../static/page404.png';
import doneAll from '../../static/done-all.svg';

export default { page404, doneAll };
